var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWireUploadDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 43,
    viewBox: "0 0 40 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3812 1.18087C20.1717 0.939092 19.8059 0.940145 19.5965 1.17976L9.36871 12.9293C9.26397 13.0497 9.20589 13.2105 9.20589 13.3811C9.20589 13.5507 9.26303 13.7116 9.36871 13.8308C9.57827 14.0726 9.94401 14.0716 10.1535 13.8319L19.4336 3.17105L19.4336 29.9764C19.4336 30.3277 19.6821 30.6143 19.9888 30.6143C20.2954 30.6143 20.544 30.3276 20.544 29.9764L20.544 3.17105L29.8231 13.8319C29.9289 13.9512 30.0679 14.019 30.2165 14.019C30.3641 14.019 30.5041 13.9512 30.6089 13.8319C30.7146 13.7116 30.7718 13.5507 30.7718 13.3811C30.7718 13.2104 30.7137 13.0497 30.6089 12.9293L20.3812 1.18087Z",
    fill: "#093549",
    stroke: "#093549",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3032 33.1816C37.9311 33.1816 37.6275 33.6063 37.6275 34.1268V39.3372H2.35137V34.1268C2.35137 33.6063 2.04769 33.1816 1.67568 33.1816C1.3025 33.1816 1 33.6063 1 34.1268V40.2823C1 40.8028 1.3025 41.2276 1.67568 41.2276H38.3032C38.6764 41.2276 38.9789 40.8028 38.9789 40.2823V34.1268C38.9789 33.6063 38.6764 33.1816 38.3032 33.1816Z",
    fill: "#093549",
    stroke: "#093549",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWireUploadDocument);
export default __webpack_public_path__ + "static/media/wire-upload-document.4232af8b67250a431c8887e2dfb824ba.svg";
export { ForwardRef as ReactComponent };